function NavbarTop() {
  return (
    <section className="jumbotron navbar-expand-lg navbar d-flex align-items-center">
      <div
        className="navbar navbar-dark navbar-static-top navbar-expand-lg "
        role="navbar"
      >
        <a href="/" className="navbar-brand">
          <img className="logo" src="img/logo-salesbox2.svg" alt="logo" />
        </a>
      </div>

      <div className="collapse navbar-collapse">
        <a href="/" className="nav-item nav-link text-white">
          Pesquisar
        </a>
        <a
          href="https://salesbox.com.br/identity/"
          target="_blank"
          className="nav-item nav-link text-white"
        >
          Login Plataforma →
        </a>
      </div>
    </section>
  );
}

export default NavbarTop;
